import React from "react"

export default function ConflictToResolve() {
  return (
    <symbol id="conflict-to-resolve" viewBox="0 0 3 10" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M2.5 7h-2V.5h2V7zm-2 2.013c0-.277.098-.515.294-.714A.955.955 0 0 1 1.5 8c.267 0 .5.095.7.286.2.19.3.424.3.701a.983.983 0 0 1-.294.714A.955.955 0 0 1 1.5 10a.955.955 0 0 1-.381-.078A1.082 1.082 0 0 1 .8 9.714a.965.965 0 0 1-.3-.701z"
        fill="currentColor"
        fillRule="nonzero"
      />
    </symbol>
  )
}
